var Aneox;
(function (Aneox) {
  'use strict';

  var Galleries = (function () {

    var galleryElement;
    var galleryList;
    var currentGallery;
    var slides;
    var downloadButton;
    var isOpen = false;

    function Galleries() {
      galleryElement = $('#gallery');
      galleryList = $('#gallery-list');
      downloadButton = $('#gallery-download-button');
    }

    Galleries.prototype.open = function(galleryId) {
      isOpen = true;
      $('#page-wrapper').addClass('noscroll');
      if (currentGallery !== galleryId) {
        insertContent(galleryId);
        currentGallery = galleryId;
      } else {
        slides.filter('.active').removeClass('active');
        slides.first().addClass('active');
      }
      downloadButton.attr('href', slides.first().attr('data-bg'));
      galleryElement.fadeIn();
    };

    Galleries.prototype.close = function() {
      isOpen = false;
      galleryElement.fadeOut();
      $('#page-wrapper').removeClass('noscroll');
    };

    Galleries.prototype.next = function() {
      var next = slides.filter('.active').removeClass('active').next();
      if (next.length === 0) {
        next = slides.first();
      }
      downloadButton.attr('href', next.attr('data-bg'));
      next.addClass('active');
    };

    Galleries.prototype.previous = function() {
      var last = slides.filter('.active').removeClass('active').prev();
      if (last.length === 0) {
        last = slides.last();
      }
      downloadButton.attr('href', last.attr('data-bg'));
      last.addClass('active');
    };

    function insertContent(galleryId) {
      var fragment = $(document.createDocumentFragment());
      
      //_.find(Aneox.Data.Data.galleries, { id: galleryId }).slides
        _.find(app.dataGalerie, { id: galleryId }).slides    
      .forEach(function(slide, index) {
        fragment.append('<li data-bg="' + slide.img +
          '" class="gallery-slide background-cover lazyload' + (index === 0 ? ' active' : '') + '"/>');
      });

      slides = fragment.children();
      galleryList.append(fragment);
    }

    return Galleries;
  })();

  Aneox.Galleries = Galleries;
})(Aneox || (Aneox = {}));